module.exports = __webpack_public_path__ + "static/img/2030-1.765694b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/2030-1.jpg
// module id = aR3S
// module chunks = 0